module.exports = "/static/assets/c05560c347359cf80b955e5ade228e61.png";